module.exports = __webpack_public_path__ + "fonts/FSSinclair-Italic.cbf9988a.otf";